import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import Style from "./OneCategoryDIscountListTabel.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, XLg } from "react-bootstrap-icons";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";

const OneCategoryDIscountListTabel = ({ openModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  let dataSource = [];
  let index = 1;
  data &&
    data.forEach((element) => {
      element.category.forEach((e)=>{
        if(parseInt(e.min_discount)===parseInt(e.max_discount)&&parseInt(e.max_discount)!==0 ){
          dataSource.push({
            key:index,
            categoryId:e.id,
            supplierId:element.id,
            pName:element.name,
            type:element.type==='food'?'رستوران':'سوپرمارکت',
            CName:e.category_persian===undefined?e.category:e.category_persian,
            DiscountValue:separate(e.min_discount)
          })
        }
      })
      index=index+1
    });
  const columns = [
    {
      title: "نام تامین کننده",
      dataIndex: "pName",
      key: "pName",
      width: "20%",
      ...getColumnSearchProps("pName", "نام تامین کننده "),

    },
    {
      title: "نوع تامین کننده",
      dataIndex: "type",
      key: "type",
      width: "20%",
      ...getColumnSearchProps("type", "نوع تامین کننده  "),

    },
    {
      title: "نام دسته بندی ",
      dataIndex: "CName",
      key: "CName",
      width: "20%",
      ...getColumnSearchProps("CName", "نام دسته بندی  "),

    },
    {
      title: "تخفیف  اعمال شده",
      dataIndex: "DiscountValue",
      key: "DiscountValue",
      width: "20%",
      ...getColumnSearchProps("DiscountValue", "تخفیف کل اعمال شده"),
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "20%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => openModal(1, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          <button
              onClick={() => openModal(2, record)}
              className={Style.deleteBtn}
            >
              <XLg />
            </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }} className={Style.TabelHolder}>
      <Table
        pagination={{ pageSize: 50 }}
        columns={columns}
        dataSource={dataSource}
        loading={data === undefined ? true : false}
      />
    </div>
  );
};

export default OneCategoryDIscountListTabel;
